import { render, staticRenderFns } from "./SmartSearchOptionSelector.vue?vue&type=template&id=64a4aa8a"
import script from "./SmartSearchOptionSelector.vue?vue&type=script&lang=ts"
export * from "./SmartSearchOptionSelector.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports